import React, { useContext, useState } from "react";
import { PropTypes } from "prop-types";

import CustomModal from "../../../react_utils/modals/CustomModal";

import CustomForm from "../../../react_utils/form/CustomForm";
import { CustomButton } from "../../../react_utils/StyledElements";
import ModalFooter from "../../../react_utils/modals/ModalFooter";
import { AuthContext } from "../../../shared/contexts/AuthContext";
import { MessagingContext } from "../../MessagingContext";
import useGrowattAccountForm from "../../../shared/hooks/location/useGrowattAccountForm";

export const getCreateGrowattAccountOpenButton = (toggle) => {
  return (
    <CustomButton
      onClick={toggle}
      style={{ maxWidth: "300px" }}
      icon="account"
      id="add_growattaccount_btn"
    >
      Konto hinzufügen
    </CustomButton>
  );
};

export const getEditGrowattAccountOpenButton = (toggle) => {
  return (
    <CustomButton onClick={toggle} icon="info">
      Growattkonto
    </CustomButton>
  );
};

export default function GrowattAccountFormModal({
  growattAccount,
  location = null,
  resetParent,
  modalProps = {},
}) {
  const { user, apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);
  const [isFocused, setIsFocused] = useState(false);

  const { form, onSubmit, onDelete } = useGrowattAccountForm(
    growattAccount,
    location,
    resetParent,
    showMessage,
    apiClient,
    isFocused,
  );

  if (!user?.is_superuser) return null;

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const getFooter = (toggle) => {
    return (
      <ModalFooter
        buttons={[
          {
            label: growattAccount ? "Speichern" : "Erstellen",
            onClick: () => onSubmit(toggle),
          },
          growattAccount && {
            label: "Löschen",
            onClick: () => onDelete(toggle),
            props: { color: "error" },
          },
        ]}
      />
    );
  };

  return (
    <>
      <CustomModal
        title="Growattkonto"
        getFooter={getFooter}
        {...modalProps}
        onToggle={onToggle}
      >
        <CustomForm
          template={form.template}
          form={form.form}
          setForm={form.setForm}
          showMissingFields={form.showMissingFields}
        />
      </CustomModal>
    </>
  );
}

GrowattAccountFormModal.propTypes = {
  location: PropTypes.object,
  growattAccount: PropTypes.object,
  resetParent: PropTypes.func,
  modalProps: PropTypes.object,
};
